import React from "react";
import { AddRounded, RemoveRounded } from "@mui/icons-material";
import { Button, InputAdornment, TextField } from "@mui/material";

const InputQty = ({ value, onChange, onIncrease, onDecrease, ...other }) => {
  return (
    <TextField
      size="small"
      value={value}
      onChange={onChange}
      type="number"
      className="rmv-arrow"
      sx={{
        "& .MuiInputBase-root": {
          width: "120px",
          fontSize: "0.95rem",
          fontWeight: 500,
          padding: "0px",
          color: "var(--dark-color)",
          boxShadow: "var(--shadow-xs)",
        },
        "& .MuiInputBase-input": {
          padding: "4px 0px 3px 0px", // less vertical padding
          textAlign: "center",
        },
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Button
              onClick={onDecrease && onDecrease}
              size="small"
              sx={{
                "&:hover": { background: "none" },
                background: "none",
                borderRadius: 0,
                minWidth: "22px",
                padding: "0 6px",
                height: "26px",
                borderRight: "1px solid var(--graySM-color)",
                minHeight: "unset",
              }}
            >
              <RemoveRounded sx={{ fontSize: "20px" }} />
            </Button>
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            <Button
              onClick={onIncrease && onIncrease}
              size="small"
              sx={{
                "&:hover": { background: "none" },
                background: "none",
                borderRadius: 0,
                minWidth: "22px",
                padding: "0 6px",
                height: "26px",
                borderLeft: "1px solid var(--graySM-color)",
                minHeight: "unset",
              }}
            >
              <AddRounded sx={{ fontSize: "20px" }} />
            </Button>
          </InputAdornment>
        ),
      }}
      {...other}
    />
  );
};

export default InputQty;
